import checkoutReducer from "./checkoutReducer";

export const checkoutReducers = {
  checkout: checkoutReducer,
};
